module.exports = __webpack_public_path__ + "img/gb5780.prt.13125eec.jpg";